// Ditado (0.65): tocar no 🎤, falar, e o texto aparece escrito, no idioma do app. Não grava nem guarda áudio:
// usa o reconhecimento de fala do próprio celular (Android, iPhone) ou do navegador.
// O módulo nativo chega com o app novo (0.65); no app antigo o botão avisa que precisa atualizar.
import { Platform } from 'react-native';
import { requireOptionalNativeModule } from 'expo-modules-core';
import { idioma } from './i18n';

const LINGUA: Record<string, string> = { 'pt-BR': 'pt-BR', 'pt-PT': 'pt-PT', en: 'en-US', es: 'es-ES', fr: 'fr-FR', it: 'it-IT', de: 'de-DE',
  zh: 'zh-CN', ja: 'ja-JP', hi: 'hi-IN', bn: 'bn-IN', ru: 'ru-RU', id: 'id-ID', ar: 'ar-SA' };
export const linguaDoApp = () => LINGUA[idioma()] ?? 'pt-BR';

type Mod = {
  start: (o: object) => void; stop: () => void; abort: () => void;
  requestPermissionsAsync: () => Promise<{ granted: boolean }>;
  addListener: (ev: string, f: (e: any) => void) => { remove: () => void };
};
const nativo = () => (Platform.OS === 'web' ? null : requireOptionalNativeModule<Mod>('ExpoSpeechRecognition'));
const web = () => (Platform.OS === 'web' && typeof window !== 'undefined' ? ((window as any).SpeechRecognition || (window as any).webkitSpeechRecognition) : null);

export const ditadoDisponivel = () => !!(nativo() || web());

export type Sessao = { parar: () => void };
/** Começa a ouvir. onTexto recebe cada trecho já reconhecido (final); onFim avisa quando parar. */
export async function ouvir(onTexto: (t: string) => void, onFim: (erro?: string) => void, onParcial?: (t: string) => void): Promise<Sessao | null> {
  const lang = linguaDoApp();
  const N = nativo();
  if (N) {
    const p = await N.requestPermissionsAsync().catch(() => ({ granted: false }));
    if (!p.granted) { onFim('permissao'); return null; }
    const subs = [
      N.addListener('result', e => {
        const tx = String(e?.results?.[0]?.transcript ?? '').trim();
        if (!tx) return;
        if (e.isFinal) onTexto(tx); else onParcial?.(tx);
      }),
      N.addListener('error', e => { limpar(); onFim(String(e?.error ?? 'erro')); }),
      N.addListener('end', () => { limpar(); onFim(); }),
    ];
    const limpar = () => subs.forEach(s => s.remove());
    // continuous: continua ouvindo até tocar de novo no 🎤 (Android 13+ e iPhone); sem gravar áudio
    N.start({ lang, interimResults: true, continuous: true, addsPunctuation: true, recordingOptions: { persist: false } });
    return { parar: () => { try { N.stop(); } catch { /* já parou */ } } };
  }
  const SR = web();
  if (SR) {
    const r = new SR();
    r.lang = lang; r.interimResults = true; r.continuous = true;
    r.onresult = (ev: any) => {
      for (let i = ev.resultIndex; i < ev.results.length; i++) {
        const tx = String(ev.results[i][0]?.transcript ?? '').trim();
        if (!tx) continue;
        if (ev.results[i].isFinal) onTexto(tx); else onParcial?.(tx);
      }
    };
    r.onerror = (ev: any) => onFim(String(ev?.error ?? 'erro'));
    r.onend = () => onFim();
    r.start();
    return { parar: () => { try { r.stop(); } catch { /* já parou */ } } };
  }
  onFim('indisponivel');
  return null;
}

/** Junta o trecho ditado ao texto que já existe (com espaço, e maiúscula no começo de frase). */
export function juntarDitado(atual: string, novo: string) {
  if (!atual.trim()) return novo.charAt(0).toUpperCase() + novo.slice(1);
  const fimFrase = /[.!?]\s*$/.test(atual);
  const n = fimFrase ? novo.charAt(0).toUpperCase() + novo.slice(1) : novo;
  return atual.replace(/\s*$/, '') + ' ' + n;
}
